export default __webpack_public_path__ + "0248f6d2d5415b1b62d04c57a3de4f9924ab6676/dd310f1c73ee98664ba9acf92580b449.png";